import React, { useContext, useEffect, useRef, useState } from 'react'
import { Collapse } from 'react-bootstrap';
import AddNewComp from './AddNewComp';
import { changeFuns } from './Pare';
import $ from "jquery";
import Loader from 'react-loader-spinner';

function Child({ data, parentName, currentKey, InputKey, nested = false }) {
    const [addNewValue, setAddNewValue] = useState("");
    const [openMAE, setOpenMAE] = useState(false);
    const [openAdditionalCollapse, setOpenAdditionalCollapse] = useState(false);
    const [addAdditional, setAddAdditional] = useState([]);

    const newAdditional = require('../../Back/pages/client/AssessmentAddAdditional.json');
    const substanceUseAbuse_with_addnew = require('../../Back/pages/client/substanceUseAbuse_with_addnew.json');

    const measurementAndEvidenced = require('../../Back/pages/client/measurementAndEvidenced.json');
    const reportedByAssessment = require('../../Back/pages/client/reportedByAssessment.json');

    const { checkedFun, checkSelectedKeys, tmpAllAddNewData, setCheckboxLoader, editMode } = useContext(changeFuns);
    const [addNew, setaddNew] = useState([]);
    const hasChildSections = Boolean(data.child && data.child.length > 0);
    const [childOpen, setChildOpen] = useState(false);
    const radioName = parentName + "_" + currentKey;

    const resolveAddNewEditModeName = (fieldName, fieldValue, index) => {
        if (data.type === 'radio') {
            return data.same_name ? `${parentName}_${data.same_name}` : radioName;
        }
        return fieldName + fieldValue + index;
    };

    const resolveAddNewArrayValue = () =>
        `${parentName}${data.same_name ? `_${data.same_name}` : ''}_addNewArray`;

    const findAddNewInput = (fieldName, fieldValue, editModeName) => {
        const addNewArrayValue = resolveAddNewArrayValue();
        const matches = Array.from(
            document.querySelectorAll(`input[value="${addNewArrayValue}"]`)
        ).filter((input) => {
            try {
                const parsed = JSON.parse(input.id);
                return (
                    parsed.value === fieldValue &&
                    parsed.editModeName === editModeName
                );
            } catch {
                return false;
            }
        });
        return matches[matches.length - 1] || null;
    };

    const addNewItem = (name) => {
        let value = addNewValue;
        if (value.trim() === '') return false;
        const id = name + "_" + (value.split(' ').join('_'));
        const nextIndex = addNew.length;
        const editModeName = resolveAddNewEditModeName(name, value, nextIndex);
        const newElement = {
            name,
            type: data.type,
            id,
            value,
            addNewChild: data.addnew_child,
            editModeName,
            autoSelect: true,
        };
        setAddNewValue("");
        setaddNew((prev) => [...prev, newElement]);
    }

    const pName = parentName + '_' + (data.type === 'checkbox' ? data.key : '');

    const name = data.name;
    const id = parentName + "_" + data.key;

    useEffect(() => {
        if (!hasChildSections) {
            return;
        }
        if (editMode?.[pName] || editMode?.[id]) {
            setChildOpen(true);
            return;
        }
        const el =
            document.getElementById(id) ||
            document.getElementById(pName.replace(/_$/, ''));
        if (el?.checked) {
            setChildOpen(true);
        }
    }, [editMode, pName, id, hasChildSections]);

    useEffect(() => {
        if (!hasChildSections) {
            return undefined;
        }
        const onSectionReset = (event) => {
            const prefix = event?.detail?.prefix;
            if (!prefix) {
                return;
            }
            const sectionKey = id || pName.replace(/_$/, '');
            if (
                sectionKey.startsWith(prefix) ||
                pName.startsWith(prefix) ||
                parentName.startsWith(prefix.replace(/_$/, ''))
            ) {
                setChildOpen(true);
            }
        };
        window.addEventListener('sentence-builder-section-reset', onSectionReset);
        return () => {
            window.removeEventListener('sentence-builder-section-reset', onSectionReset);
        };
    }, [hasChildSections, id, pName, parentName]);

    const notesField = (pname, name) => {
        return (
            name.map((e, i) => {
                return <div key={`${pname}-note-${i}`} className={'my-2 ' + (data.inline ? 'd-inline-block' : '')}>
                    {
                        e.type === 2 && e.align_text_start
                            ? <span>{e.text}</span>
                            : ""
                    }
                    <input type={"text"}
                        onBlur={(e) => checkedFun(e)}
                        onKeyDown={(e) => e.key === "Enter" ? checkedFun(e) : ""}
                        name={
                            pname + (e.prefix_name ?? "") + (data.type === "checkbox" ? "_notes" : "notes" + (name.length > 1 ? i : ""))
                        }
                        className='d-inline-block form-control form-control-solid'
                        placeholder=""
                        defaultValue={(e.show_text && e.type !== 2) ? e.text : ""} />
                        {(e.type === 2 && !e.align_text_start && e.end_text) ? <span className='end_text me-2 d-inline-block'>{e.end_text}</span>
                            : ""}
                    {
                        e.type === 2 && !e.align_text_start
                            ? <span>{e.text}</span>
                            : ""
                    }
                    {
                        (e.type === 2 && e.align_text_start && e.end_text)
                            ? <span className='end_text mx-2 d-inline-block'>{e.end_text} g</span>
                            : ""
                    }
                </div>

            })
        )
    }

    /* 25-09-22 : 
        we just need an reference of current element for figure out its previous value, 
        we take an let variable and onMouseOver event just store current checked value in it, 
        so on click event we easily figure out current checked value for radio button.
    */
    const CheckRadioComp = (type, id, pname, name, showText = true, inline = false) => {
        let previousChecked = false;
        const clickFun = (g) => {
            if (g.target.type === 'radio' && !inline) {
                g.target.checked = !previousChecked;
                checkedFun(g);
                previousChecked = !previousChecked;
            } else {
                checkedFun(g);
                if (g.target.type === 'radio') {
                    previousChecked = g.target.checked;
                }
            }
            if (hasChildSections) {
                setChildOpen(Boolean(g.target.checked));
            }
            if (data.collapse) {
                setOpenAdditionalCollapse(g.target.checked);
            }
            setOpenMAE(g.target.checked);
        }
        const wrapperClass = inline
            ? 'c-pointer form-check form-check-sm form-check-custom form-check-solid d-inline-flex align-items-center mb-0 me-2'
            : 'c-pointer form-check form-check-sm form-check-custom form-check-solid d-block me-2';
        return (
            <div className={wrapperClass}>
            <input
                className={'form-check-input widget-9-check'}
                type={type}
                id={id}
                onMouseOver={(e) => { previousChecked = e.target.checked; }}
                name={type === "checkbox" ? pname : (data.same_name ? pname + data.same_name : radioName)}
                placeholder={data.placeholder ?? 'Option'}
                {...(type === 'radio'
                    ? inline
                        ? { onChange: clickFun }
                        : { onClick: clickFun }
                    : { onChange: clickFun })}
            />
            {
                showText ? <label htmlFor={id} className="align-items-center fs-6 text-dark fw-bold form-label mb-2 customCheckValue">{name}</label> : ""
            }
            {hasChildSections && (
                <button
                    type="button"
                    className="btn btn-sm btn-primary text-center"
                    id={`${id}CollapseBtn`}
                    style={{ borderRadius: '5px', padding: '2px 2px 2px 7px', marginRight: '10px' }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setChildOpen((prev) => !prev);
                    }}
                >
                    <i className={childOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'} />
                </button>
            )}
            {data.measurementAndEvidenced && <>
                <button type='button' className='btn btn-sm btn-primary text-center' id={`${parentName}CollapseBtn`} style={{borderRadius: "5px", padding:'2px 2px 2px 7px', marginRight:"10px"}} onClick={() => {
                // setOpenAdditionalCollapse(!openAdditionalCollapse)
                const ids = parentName+'Collapse';
                const btnIds = parentName+'CollapseBtn';
                // console.log(btnIds,$(`.${btnIds} .fa`).hasClass( "fa-angle-up" ))
                if($(`#${btnIds} .fa`).hasClass( "fa-angle-up" )){
                    $(`#${btnIds} .fa`).removeClass("fa-angle-up");
                    $(`#${btnIds} .fa`).addClass("fa-angle-down");
                } else {
                    $(`#${btnIds} .fa`).addClass("fa-angle-up");
                    $(`#${btnIds} .fa`).removeClass("fa-angle-down");
                }
                if($(`.${ids}`).hasClass( "show" )){
                    $(`.${ids}`).removeClass("show");
                    
                } else {
                    $(`.${ids}`).addClass("show");
                }
            }}><i className={$(`.${parentName+'Collapse'}`).hasClass( "show" ) ? "fa fa-angle-up" :"fa fa-angle-down"}></i></button>
            </>}
            {
                name == 'Interventions' ?
                    <>
                        {/* <input
                            className={'form-check-input widget-9-check'}
                            type={type}
                            id={id + "_all"}
                            onMouseOver={(e) => previousChecked = e.target.checked}
                            name={type === "checkbox" ? pname : (data.same_name ? pname + data.same_name : radioName)}
                            placeholder={data.placeholder ?? 'Option'}
                            onClick={() => {
                                setCheckboxLoader(true)
                                setTimeout(() => checkAllChild(data, id),30)
                            }}
                        />
                        <label htmlFor={id + "_all"} className="align-items-center fs-6 text-dark fw-bold form-label mb-2 customCheckValue">Select All</label> */}
                    </>
                    : ""
            }
        </div>
        );
    }

    function checkAllChild(data, id) {
        setTimeout(() =>{
            setCheckboxLoader(false)
        },2000)
        let selectAllStatus = $("#" + id + "_all").prop('checked')
        let childList = data.child[0]
        for (let i = 0; i < childList.length; i++) {
            const element = id + "_" + childList[i].key;
            const isChecked = $("#" + element).prop('checked', selectAllStatus);
            if (isChecked && isChecked[0]) {
                checkedFun({ target: isChecked[0] })
            }
        }
            const isChecked = $("#" + id).prop('checked', selectAllStatus);
            if (isChecked && isChecked[0]) {
                checkedFun({ target: isChecked[0] })
            }

        // CheckRadioComp(type, id, pname, name)
    }


    const createAddNewField = (name, id, type, value, count, addNewChild = [], defaultCheck, editModeName, autoSelectOnMount = false) => {
        const resolvedEditModeName =
            editModeName ??
            (type === 'radio'
                ? (data.same_name ? `${parentName}_${data.same_name}` : radioName)
                : name + value + count);
        return (
            <li className={'d-inline-block'}>
                <AddNewComp InputKey={InputKey}
                    addNewIndex={count}
                    data={data}
                    name={type === 'radio' ? name : resolvedEditModeName}
                    parentName={parentName}
                    type={type}
                    value={value}
                    checkedFun={checkedFun}
                    setOpenMAE={setOpenMAE}
                    i={count}
                    radioName={radioName}
                    editModeName={resolvedEditModeName}
                    defaultCheck={defaultCheck ?? true}
                    autoSelectOnMount={autoSelectOnMount} />
                {
                    addNewChild
                        ? addNewChild.map((e, i) => <ul><li> {e.map((f, j) => <Child data={f} parentName={parentName + "_" + value} currentKey={j} InputKey={j} />)}</li></ul>)
                        : ""
                }
                {
                    data.measurementAndEvidenced
                        ? measurementAndEvidencedFun(value)
                        : ""
                }
                {
                    data.substanceUseAbuse_with_addnew
                        ? substanceUseAbuse_with_addnew.map((e, i) => <ul><li>{e.map((f, j) => <Child data={f} parentName={parentName + "_" + value} currentKey={i} InputKey={j} />)} </li></ul>)
                        : ""
                }
            </li>
        )
    }

    const checkradioField = (pname, id, name, type) => {
        const inlineRadio = type === 'radio' && Boolean(data.same_name);
        return (
            <>
                {
                    CheckRadioComp(type, id, pname, name, true, inlineRadio)
                }
                {
                    data.measurementAndEvidenced
                        ? measurementAndEvidencedFun()
                        : ""
                }
            </>
        )
    }

    const addnewField = (name) => {

        return (
            <>
                {
                    addNew
                        ? addNew.map((e, i) => createAddNewField(
                            e.name,
                            e.id,
                            e.type,
                            e.value,
                            i,
                            e.addNewChild,
                            e.checked,
                            e.editModeName,
                            e.autoSelect
                        ))
                        : ""
                }
                <div className="d-inline-block form-check form-check-sm form-check-custom d-inline form-check-solid">
                    <div className="position-relative">
                        <input
                            type="text"
                            className='form-control form-control-solid'
                            name={name}
                            onChange={(e) => setAddNewValue(e.target.value)}
                            value={addNewValue}
                            placeholder="Add New"
                            style={{ maxWidth: "150px" }}
                        />
                        <button type='button' className="position-absolute btn btn-sm btn-primary"
                            style={{ right: "2px", top: "2px", borderRadius: "5px", padding: "5px 10px" }}
                            onClick={() => addNewItem(name)}>
                            <b className='h4 text-white'>+</b>
                        </button>
                    </div>
                </div>
            </>
        )
    }

    const measurementAndEvidencedFun = (addNew = false) => {
        return measurementAndEvidenced.map((e, i) => (
            <Collapse id={parentName + "Collapse"} in={openMAE}>
                <div className={`ml-4 ${parentName + "Collapse"}`}>
                    {
                        e.map((f, j) => <Child data={f} parentName={addNew ? parentName + "_" + addNew : id} currentKey={i} InputKey={i} />)
                    }
                </div>
            </Collapse>
        ))
    }

    const radioGroup = () => {
        return (
            <div className="d-inline-block form-check form-check-sm form-check-custom d-inline form-check-solid">
                <label className="align-items-center fs-6 fw-bold form-label mb-2 customCheckValue">{name}</label>
            </div>
        )
    }

    const inlineNoteField = () => {
        return (
            <div className="cp-inline-notes-row my-2 mx-2 pr-2">
                {data.with_checkbox
                    ? CheckRadioComp(
                        data.type,
                        id,
                        pName,
                        name,
                        false,
                        true
                    )
                    : null}
                {data.start_text
                    ? <span className="d-inline-block me-2">{data.start_text}</span>
                    : null}
                <input
                    type="text"
                    onBlur={(e) => checkedFun(e)}
                    onKeyDown={(e) => (e.key === 'Enter' ? checkedFun(e) : null)}
                    name={id + '_notes'}
                    placeholder={data.placeholder ?? ''}
                    className="form-control form-control-solid cp-inline-notes-row__input"
                    defaultValue=""
                />
                {data.end_text ? <span className="end_text">{data.end_text}</span> : null}
            </div>
        );
    }


    const aditional = () => {
        return <button type="button" className='btn btn-primary' onClick={() => setAddAdditional([...addAdditional, addAdditional.length + 1])}>Add Additional</button>
    }

    const isCollapse = (e, i) => {
        let collapseOpen = childOpen;
        if (data.type === 'radio') {
            collapseOpen = childOpen || Boolean(document.getElementById(id)?.checked);
        } else if (!document.getElementById(pName) && data.type !== 'radio') {
            collapseOpen = true;
        }
        return <>
        
        <Collapse id={pName + "Collapse"} className={id+'Collapse'} in={collapseOpen}>
                <div className="ml-4 my-2 collapsible cp-radio-inline-group">
                {
                data.notes_first
                    ?
                    data.notes !== undefined
                        ? <>
                        {notesField(pName, data.notesText)}
                        <br/>
                        </>
                        : ""
                    : ""
            }
                    {
                        e.map((f, j) => (
                            <Child
                                key={`${id}-nested-${j}-${f.key ?? j}`}
                                data={f}
                                parentName={id}
                                currentKey={i}
                                InputKey={j}
                                nested
                            />
                        ))
                    }
                </div>
            </Collapse>
            </>
        // } else {
        //     return <div className='ml-4 my-2'>
        //         {
        //             e.map((f) => <Child data={f} parentName={id} currentKey={i} InputKey={i} />)
        //         }
        //     </div>
        // }
    }

    React.useEffect(() => {
        if (tmpAllAddNewData && tmpAllAddNewData[id.replace('_add-new', '')]) {
            setaddNew(tmpAllAddNewData[id.replace('_add-new', '')])
        }
    }, [tmpAllAddNewData])


    const itemClassName = `${(data.child && data.child.length > 0) ? "d-block" : "d-inline-block"}`;
    const ItemTag = nested ? 'div' : 'li';

    return (
        <ItemTag className={itemClassName}>
            {
                data.for === "normal"
                    ? checkradioField(pName, id, name, data.type)
                    : (
                        data.for === "radio-group" || data.for == "inline-text"
                            ? radioGroup()
                            : (data.for === 'addnew'
                                ? addnewField(pName + (data.type == 'radio' ? 'add-new' : ''))
                                : (data.for === "inline-notes"
                                    ? inlineNoteField()
                                    : ""
                                )
                            )
                    )
            }
            {
                data.notes_first && !data.child
                    ?
                    data.notes !== undefined
                        ? notesField(pName, data.notesText)
                        : ""
                    : ""
            }
            {
                data.child && data.child.length > 0
                    ? data.child.map((e, i) => (
                        <React.Fragment key={`${id}-collapse-group-${i}`}>
                            {isCollapse(e, i)}
                        </React.Fragment>
                    ))
                    : null
            }
            {
                // data.child !== undefined
                //     ? data.child.map((e, i) => {
                //         return isCollapse(e, i)
                //     })
                //     : ''
            }

            {
                !data.notes_first
                    ?
                    data.notes !== undefined
                        ? notesField(pName, data.notesText)
                        : ""
                    : ""
            }
            {
                addAdditional.map((e, i) => (
                    <ul key={`${id}-add-additional-${i}`}><hr /><li>
                        {
                            data.additional_with_reportedBy
                                ? reportedByAssessment.map((l, m) => (
                                    <Child
                                        key={`${id}-rba-add-${i}-${m}-${l.key ?? m}`}
                                        data={l}
                                        parentName={pName + "_" + (i + 1)}
                                        currentKey={i}
                                        InputKey={i}
                                    />
                                ))
                                : null
                        }
                        {
                            newAdditional.filter((l) => l.for == data.additional_id)[0].child.map((f, j) => (
                                <div key={`${id}-add-child-${i}-${j}`}>
                                    {
                                        f.map((h, k) => (
                                            <Child
                                                key={`${id}-add-${i}-${j}-${k}-${h.key ?? k}`}
                                                data={h}
                                                parentName={id + "_" + (i + 1)}
                                                currentKey={i}
                                                InputKey={i}
                                            />
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </li></ul>
                ))
            }
            {
                data.additional || data.for == 'add_additional'
                    ? aditional()
                    : ""
            }
        </ItemTag>
    )
}
export default Child